import { getProUrl as buildProUrl } from "@sill/shared";

const PRO_URL = import.meta.env.VITE_PRO_URL || "https://pro.usesill.com";

export function getProUrl(
  path: string,
  params?: Record<string, string>,
): string {
  return buildProUrl(PRO_URL, path, params);
}
